// import React, { Component } from 'react';
// // import '../../CSS/assets-minified/all-demo.css'
// import FPGetMail from '../components/forgotPasswordComponents/FPGetMail'
// import FPGetCode from '../components/forgotPasswordComponents/FPGetCode'
// import ChangePassword from '../components/forgotPasswordComponents/changePassword'

// class ForgotPassword extends Component{

//     constructor(props){
//         super(props)
//         this.state={
//             "RenderedComponent":0,
//             username:null,
//             email:null
//         }
//         this.showGetCodeScreen = this.showGetCodeScreen.bind(this)
//         this.showSetNewPasswordScreen = this.showSetNewPasswordScreen.bind(this)
//     }

//     showGetCodeScreen = (name, email) =>{

//         this.setState({
//             "RenderedComponent":1,
//             username:name,
//             email:email
//         })
//     }
//     showSetNewPasswordScreen = () =>{
//         this.setState({
//             "RenderedComponent":2
//         })
//     }


//     render(){
//        if(this.state.RenderedComponent === 0){
//         return(
//             <div className="center-vertical">
//                 <div className="center-content">
//                     <FPGetMail switch={this.showGetCodeScreen} />
//                 </div>
//             </div>
//         )
//        }
//        if(this.state.RenderedComponent === 1){
//         return(
//             <div className="center-vertical">
//                 <div className="center-content">
//                     <FPGetCode switch={this.showSetNewPasswordScreen} username={this.state.username} email={this.state.email}/>
//                 </div>
//             </div>
//         )   
//        }
//        if(this.state.RenderedComponent === 2){
//         return(
//             <div className="center-vertical">
//                 <div className="center-content">
//                     <ChangePassword username={this.state.username}/>
//                 </div>
//             </div>
//         )   
//        }

//     }
// }

// export default ForgotPassword;

import React from 'react';
// import '../../CSS/assets-minified/all-demo.css'
import FPGetMail from '../components/forgotPasswordComponents/FPGetMail'
import FPGetCode from '../components/forgotPasswordComponents/FPGetCode'
import ChangePassword from '../components/forgotPasswordComponents/ChangePassword'

const ForgotPassword = () => {
    const [renderedComponent, setRenderedComponent] = React.useState(0)
    const [username, setUsername] = React.useState(null)
    const [email, setEmail] = React.useState(null)

    const showGetCodeScreen = (name, email) => {
        setRenderedComponent(1)
        setUsername(name)
        setEmail(email)
    }

    const showSetNewPasswordScreen = () => {
        setRenderedComponent(2)
    }

    return (
        <div>
            {renderedComponent === 0 ?
                <div className="center-vertical">
                    <div className="center-content">
                        <FPGetMail switch={showGetCodeScreen} />
                    </div>
                </div> : <div></div>}
            {renderedComponent === 1 ?
                <div className="center-vertical">
                    <div className="center-content">
                        <FPGetCode switch={showSetNewPasswordScreen} username={username} email={email} />
                    </div>
                </div> : <div></div>}
            {renderedComponent === 2 ?
                <div className="center-vertical">
                    <div className="center-content">
                        <ChangePassword username={username} />
                    </div>
                </div> : <div></div>}
        </div>
    )
}

export default ForgotPassword

/**
 * Notes:
 * - Pagination render could be better, should not be using number or switches
 * - Needs testing
 * - Components Done: FPGetMail
 */


// WEBPACK FOOTER //
// src/Routes/ForgotPassword.js